import { configureStore } from '@reduxjs/toolkit'
import academySlice from './academySlice'

export default configureStore({
  reducer: {
    academy: academySlice,
  },
})